// extracted by mini-css-extract-plugin
export default {"link":"zB-z","disabled":"AB-z"};